import ShareholderTicketList from './shareholder_ticket_list';

export default ShareholderTicketList;
